// extracted by mini-css-extract-plugin
export default {"layout":"layout___bm4pA","bar":"bar___rGjOO"};